"use client";
import React from "react";
import { Modal, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import "./AddModal.css";

import PrescriptionTab from "../../../prescriptions/components/PrescriptionTab/PrescriptionTab";
import MedicationTab from "../MedicationTab/MedicationTab";

export default function AddModal({
  open,
  onClose,
  onUpload,
  onCreatePrescription,
  onCreateMedication,
  userId,
  doctorMode = false,
  editMedication = null,
}) {
  const { t } = useTranslation();

  const items = [
    {
      key: "prescription",
      label: t("AddModal.addModal.tabs.prescription"),
      children: (
        <div className="apm-tabpad">
          <PrescriptionTab
            accept=".pdf,.png,.jpg,.jpeg"
            onUpload={onUpload}
            onCreatePrescription={onCreatePrescription}
          />
        </div>
      ),
    },
    {
      key: "medication",
      label: t("AddModal.addModal.tabs.medication"),
      children: (
        <div className="apm-tabpad">
          {/* MedicationTab persiste directement via Redux thunk */}
          <MedicationTab
            userId={userId}
            onCreated={onCreateMedication}
            onClose={onClose}
            doctorMode={doctorMode}
            editMedication={editMedication}
          />
        </div>
      ),
    },
  ].filter((item) => !doctorMode || item.key === "medication");

  return (
    <Modal
      className="apm-modal"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={820}
      destroyOnClose
      styles={{ body: { padding: 0 } }}
    >
      <div className="apm-wrap">
        <div className="apm-head">
          {t("AddModal.addModal.header")}
        </div>

        <div className="apm-tabs">
          <Tabs defaultActiveKey="medication" animated items={items} />
        </div>
      </div>
    </Modal>
  );
}
